module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-main",
    attrs: {
      "id": "app"
    }
  }, [
    [(_vm.app.isMobile && !_vm.app.sany) ? [_c('router-view')] : [_c('router-view')]]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-750f9321"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/App.vue
// module id = 930
// module chunks = 80